import {
  CountryCode,
  formatIncompletePhoneNumber,
  getCountryCallingCode,
  getExampleNumber,
  parseIncompletePhoneNumber,
  validatePhoneNumberLength
} from 'libphonenumber-js';
// @ts-ignore
import examples from 'libphonenumber-js/examples.mobile.json';
import React, {useCallback, useMemo} from 'react';
import {Input, InputProps} from './Input';

export type PhoneNumberInputProps = InputProps & {
  countryCode?: string | null;
};

export const PhoneNumberInput = React.forwardRef<any, PhoneNumberInputProps>(
  ({onChangeText, countryCode, value, ...rest}, ref) => {
    const code = useMemo(() => {
      if (!countryCode) return '1';
      return getCountryCallingCode(countryCode as CountryCode);
    }, [countryCode]);

    const formattedValue = useMemo(() => formatIncompletePhoneNumber(value || ''), [value]);

    const placeholder = useMemo(
      () => getExampleNumber(countryCode as CountryCode, examples)?.formatInternational(),
      [countryCode]
    );

    const onChange = useCallback(
      (value: string) => {
        if (!value.startsWith('+')) {
          value = `+${code}${value}`;
        }
        if (validatePhoneNumberLength(value) === 'TOO_LONG') {
          return;
        }
        onChangeText!(parseIncompletePhoneNumber(value));
      },
      [code, onChangeText]
    );

    return (
      <Input
        {...rest}
        ref={ref}
        value={formattedValue}
        onChangeText={onChange}
        placeholder={placeholder}
        autoComplete="tel"
        textContentType="telephoneNumber"
        keyboardType="phone-pad"
      />
    );
  }
);
